module.exports = __webpack_public_path__ + "img/sh_fb.7481cf3a.svg";